import startOfDay from 'date-fns/startOfDay'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { Colored } from '../../../components'
import type { Promo } from '../../../types'

export default function PromoStatus({ promo }: { promo: Promo }) {
    const { t } = useTranslation()
    const { date_start, date_end } = promo
    const today = startOfDay(new Date())

    if (date_start > today) {
        return <Colored color="yellow">{moment(date_start).fromNow()}</Colored>
    }

    if (date_end < today) {
        return <Colored color="red">{t('promo-status-completed')}</Colored>
    }

    return <Colored color="green">{t('promo-status-active')}</Colored>
}
